// Helpers para mostrar valores de selects múltiples
export const displayMultipleSelectData = (rowData, field) => {
    if (!rowData[field]) return "";
    return rowData[field]
        .map(item => item?.value || item)
        .filter(Boolean)
        .join(", ");
};
